import { createSlice } from '@reduxjs/toolkit';

export const auctionSlice = createSlice({
  name: 'auction',
  initialState: {},
  reducers: {},
});

export default auctionSlice.reducer;
